'use client';
import { useState } from 'react';
import { parseMarkdown } from '@/lib/markdown';
import type { SectionFaqItem } from '@/lib/cms';
interface Props {
  items: SectionFaqItem[];
}

export default function FaqAccordion({ items }: Props) {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <div>
      {items.map((item, i) => {
        const isOpen = openId === item.id;
        const isLast = i === items.length - 1;
        return (
          <div
            key={item.id}
            style={{
              borderTop: '1px solid var(--gold-pale)',
              ...(isLast ? { borderBottom: '1px solid var(--gold-pale)' } : {}),
            }}
          >
            <button
              onClick={() => setOpenId(isOpen ? null : item.id)}
              aria-expanded={isOpen}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '2rem',
                padding: 'clamp(1.6rem, 2vw, 2.4rem) 0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              <h3
                className="card-title"
                style={{ fontSize: 'clamp(1.8rem, 2vw, 2.4rem)', margin: 0 }}
              >
                {item.question}
              </h3>
              <span
                aria-hidden="true"
                style={{
                  flexShrink: 0,
                  width: '2.8rem',
                  height: '2.8rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  border: '1px solid var(--gold-pale)',
                  color: 'var(--gold)',
                  fontSize: '2rem',
                  lineHeight: 1,
                  transition: 'transform 0.3s ease, border-color 0.3s ease',
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  borderColor: isOpen ? 'var(--gold)' : undefined,
                }}
              >
                +
              </span>
            </button>

            <div
              style={{
                display: 'grid',
                gridTemplateRows: isOpen ? '1fr' : '0fr',
                transition: 'grid-template-rows 0.35s ease',
              }}
            >
              <div style={{ overflow: 'hidden' }}>
                <div
                  className="section-body cms-rich-text"
                  style={{
                    fontSize: 'clamp(1.4rem, 1.3vw, 1.6rem)',
                    lineHeight: 1.8,
                    paddingBottom: 'clamp(1.6rem, 2vw, 2.4rem)',
                  }}
                  dangerouslySetInnerHTML={{ __html: parseMarkdown(item.answer) }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
